import type { THomeSection } from '~/layers/homepage/data/types'
import { make as makeCollection } from '~/layers/homepage/data/adapters/homeSectionCollectionAdapter'
import { make as makeSlider } from '~/layers/homepage/data/adapters/homeSectionSliderAdapter'
import { make as makeAnimation } from '~/layers/homepage/data/adapters/homeSectionAnimationAdapter'
import { make as makeDiamondHistory } from '~/layers/homepage/data/adapters/homeSectionDiamondHistoryAdapter'
import { make as makeCustomSlider } from '~/layers/homepage/data/adapters/homeSectionCustomSlider'
import type { APIHomeSection } from '~/api/commonApi'

export const homeSectionsDataProvider = () => {
  return {
    async load() {
      let apiSections = await useNuxtApp().$api.common.homepage()
      let sections: THomeSection[] = []

      apiSections = apiSections.sort((a, b) => a.sort - b.sort)

      for (const apiSection of apiSections) {
        const index = apiSections.indexOf(apiSection)

        let section = makeSection(apiSection, index)

        if (section === null) {
          continue
        }

        if (!Array.isArray(section)) {
          section = [section]
        }

        sections = [...sections, ...section]
      }

      return sections
    },
  }
}

const makeSection = (apiSection: APIHomeSection, index: number): THomeSection | THomeSection[] | null => {
  if (apiSection.blockType === 'collection') {
    return makeCollection(apiSection)
  }
  if (apiSection.blockType === 'slider') {
    return makeSlider(apiSection, index)
  }

  if (apiSection.blockType === 'animation') {
    return makeAnimation(apiSection, index)
  }

  if (apiSection.blockType === 'history_diamond') {
    return makeDiamondHistory(apiSection, index)
  }

  if (apiSection.blockType === 'custom_slider') {
    return makeCustomSlider(apiSection)
  }

  return null
}
